import { action, computed, observable } from 'mobx';
import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsSummaryType } from 'types/information/price-summary/price-summary';
import { FlightsLoadedPriceSummary, FlightsShoppingPwaFlightInformationResultsLoading } from '__generated__/api';
import FlightsLoadedPriceSummaryType = FlightsLoadedPriceSummary.Fragment;
import FlightsLoadingPriceSummaryType = FlightsShoppingPwaFlightInformationResultsLoading.FlightsLoadingPriceSummaryInlineFragment;

export class PriceSummaryStore extends Store {
  @observable public priceSummary: FlightsSummaryType;
  @observable public seatSelectionSkeletonCount: number;
  @observable public additionalShoppingCompleted = false;
  public showAncillaryAlertDialog = true;

  @computed get skeletonCount(): number {
    return this.priceSummary && this.priceSummary.__typename === 'FlightsLoadingPriceSummary'
      ? (this.priceSummary as FlightsLoadingPriceSummaryType).skeletonCount
      : this.seatSelectionSkeletonCount;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setPriceSummary = (priceSummary: FlightsLoadedPriceSummaryType) => {
    if (priceSummary) {
      this.priceSummary = priceSummary;
    }
  };

  @action
  public setAdditionalShoppingCompleted = () => {
    this.additionalShoppingCompleted = true;
  };

  @action
  public setSeatSelectionLoadingSkeletonCount = (skeletonCount?: number) => {
    if (skeletonCount) {
      this.seatSelectionSkeletonCount = skeletonCount;
    }
  };

  @action
  public unsetShowAncillaryAlertDialog = () => {
    this.showAncillaryAlertDialog = false;
  };
}
